import { z } from 'zod';
import { validateInnCheckSum } from 'shared/lib';

const minDocumentIssueDate = Number(new Date('1996-12-31T21:00:00.000Z'));
const today = Number(new Date());

const minBirthDate = Number(new Date('1899-12-31T21:29:43.000Z'));

export const formSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  middleNameField: z
    .object({
      middleName: z.string(),
      doesntExist: z.boolean(),
    })
    .refine((obj) => obj.doesntExist || obj.middleName.length >= 1, {
      path: ['middleName'],
    }),
  birthDate: z.string().date().refine((val) => {
    const date = Number(new Date(val));
    return date <= today && date >= minBirthDate;
  }),
  birthPlace: z.string().min(1),
  documentType: z.string(),
  documentSerial: z.string().regex(/^\d{4}$/),
  documentNumber: z.string().regex(/^\d{3} \d{3}$/),
  documentIssuedBy: z.string().min(1),
  documentIssueDate: z.string().date().refine((val) => {
    const date = Number(new Date(val));
    return date <= today && date >= minDocumentIssueDate;
  }),
  addressReg: z.string().min(1),
  addressFactField: z
    .object({
      addressFact: z.string(),
      same: z.boolean(),
    })
    .refine((obj) => obj.same || obj.addressFact.length >= 1, {
      path: ['addressFact'],
    }),
  INN: z.string().refine((val) => (/^\d{12}$/.test(val) && validateInnCheckSum(val))),
  phoneMobile: z.string().regex(/^\+7 \d{3} \d{3} \d{2} \d{2}$/),
  personalDataConsent: z.boolean().refine((val) => val),
  isGosuslugi: z.boolean(),
});
